import { render } from "./AiLoading.vue?vue&type=template&id=cdeb6ae8&scoped=true"
import script from "./AiLoading.vue?vue&type=script&lang=js"
export * from "./AiLoading.vue?vue&type=script&lang=js"

import "./AiLoading.vue?vue&type=style&index=0&id=cdeb6ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdeb6ae8"]])

export default __exports__